const SECOND = 1000;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;

export const millisecond = {
  SECOND,
  MINUTE,
  HOUR,
};
